import VueRouter from 'vue-router'
import store from '@/store'
import _ from 'lodash'
import Cookies from 'js-cookie'
import { setLocale } from '@/helpers/locale'

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/:lang',
      component: { render: h => h('router-view') },
      children: [
        { path: '', component: () => import('../pages/dashboard.vue') },
        {
          path: 'login',
          meta: { isPublic: true, guestOnly: true },
          beforeEnter () {
            import('@/services/auth0').then(auth0 => {
              auth0.default.login() // Redirects directly to Auth0 Universal Login
            })
          }
        },
        { path: 'forgot-password', meta: { isPublic: true, guestOnly: true }, component: () => import('../pages/forgot-password.vue') },
        { path: 'logout', meta: { isPublic: true }, component: () => import('../pages/logout.vue') },
        { path: 'complete-profile', component: () => import('../pages/register.vue') },
        { path: 'auth-callback', meta: { isPublic: true }, component: () => import('../pages/auth-callback.vue') },
        { path: '*', meta: { isPublic: true }, component: () => import('../pages/404.vue') }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const toLanguage = _.get(to, 'params.lang', '')

  if (window.loadedLocale.length === 0) {
    await setLocale(window.i18n.locale)
  }

  if (window.allowedLocale.indexOf(toLanguage.toLowerCase()) < 0) {
    const currentLang = Cookies.get('locale') || window.i18n.locale

    return next({
      path: `/${currentLang}${to.path}${window.location.hash}`,
      query: window.location.search
    })
  }

  if (toLanguage !== window.i18n.locale) {
    await setLocale(toLanguage)
    Cookies.set('locale', toLanguage)
  }

  if (to.matched.some(record => record.meta.guestOnly) && store.getters['auth/isAuthenticated']) {
    return next({ path: from.path })
  }

  if (!to.matched.some(record => record.meta.isPublic) && !store.getters['auth/isAuthenticated']) {
    import('@/services/auth0').then(auth0 => {
      auth0.default.login() // Redirect to Auth0 Universal Login
    })
    return // Stop further execution
  }

  next()
})

export default router
